import type { LandscapingConfig } from '@paint-ai/shared';

export interface LandscapingPreset {
  id: string;
  name: string;
  description: string;
  plants: string[];
  lawnStyle: string;
  pathwayStyle: string;
}

export const LANDSCAPING_PRESETS: LandscapingPreset[] = [
  {
    id: 'minimal-shrubs',
    name: 'Minimal Shrubs (Unobstructed Wall)',
    description:
      'Low-profile small shrubs and neat ground grass only. No tall trees or high foliage blocking the wall colors.',
    plants: ['Low Boxwood Shrubs', 'Jasmine Shrubs (Mogra)', 'Small Border Planters'],
    lawnStyle: 'Minimalist Low Grass Bed',
    pathwayStyle: 'Clean Concrete Driveway',
  },
  {
    id: 'tropical-indian',
    name: 'Tropical Indian Garden',
    description:
      'Vibrant Areca palms, blooming Bougainvillea, Jasmine shrubs, and manicured green turf with stone pavers.',
    plants: ['Areca Palms', 'Bougainvillea (Magenta)', 'Jasmine Shrubs', 'Crotons'],
    lawnStyle: 'Manicured Emerald Lawn',
    pathwayStyle: 'Interlocking Stone Paver Pathway',
  },
  {
    id: 'modern-minimalist',
    name: 'Modern Minimalist & Turf',
    description: 'Sleek architectural Areca palms, geometric turf beds, slate planters, and concrete paver driveway.',
    plants: ['Areca Palms', 'Golden Bamboo', 'Low Boxwood Hedges'],
    lawnStyle: 'Minimalist Grass & Gravel Grid Beds',
    pathwayStyle: 'Paved Concrete Driveway with Grass Joints',
  },
  {
    id: 'executive-courtyard',
    name: 'Executive Courtyard',
    description: 'Low manicured hedges, potted ornamental palms, clean driveway pavers, and pristine lawn borders.',
    plants: ['Areca Palms', 'Monstera & Ferns', 'Low Boxwood Hedges'],
    lawnStyle: 'Manicured Emerald Lawn Edge',
    pathwayStyle: 'Interlocking Stone Paver Driveway',
  },
];

export const AVAILABLE_PLANTS = [
  'Areca Palms',
  'Bougainvillea (Magenta/Pink)',
  'Jasmine Shrubs (Mogra)',
  'Plumeria / Champa Tree',
  'Colorful Crotons',
  'Golden Bamboo',
  'Hibiscus (Gudhal)',
  'Ferns & Ornamental Grass',
];

export const LAWN_STYLES = [
  'Manicured Emerald Lawn',
  'Lush Grass Turf with Flowerbed Borders',
  'Minimalist Grass & Gravel Grid Beds',
  'Clean Turf Edge along Driveway',
];

export const PATHWAY_STYLES = [
  'Interlocking Stone Paver Pathway',
  'Basalt Stepping Stones through Lawn',
  'Paved Concrete Driveway with Grass Joints',
  'Textured Slate Tile Walkway',
];

const minimal = LANDSCAPING_PRESETS[0];

export const DEFAULT_LANDSCAPING: LandscapingConfig = {
  preset: minimal.id,
  presetName: minimal.name,
  plants: [...minimal.plants],
  lawnStyle: minimal.lawnStyle,
  pathwayStyle: minimal.pathwayStyle,
};

export const CUSTOM_LANDSCAPING = { preset: 'custom', presetName: 'Custom Landscaping' } as const;
